import React from "react";

import TeamCard from "./ChildComponents/TeamCard/TeamCard.view";
import BigCardsAccordion from "./ChildComponents/BigCardsAccordion/BigCardsAccordion";

import "./BigCardsComponent.style.scss";

const BigCardsComponent = ({ card }) => {
  return (
    <section className="events-cards-section">
      <div
        className="events-cards-wrapper mx-auto py-4"
        style={{ backgroundImage: `url(${card.bigCardbackgroundImage})` }}
      >
        <div className="container h-100 d-flex flex-column justify-content-center align-items-center flex-lg-row">
          <div className="content-wrapper text-center text-lg-start">
            {card.title}

            {card.subtitle}

            <BigCardsAccordion accordionData={card.accordion} />
          </div>

          <div className="ms-lg-auto d-flex flex-column justify-content-center h-100">
            <TeamCard {...card.smallCard} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BigCardsComponent;
